/**
 * @desc 根据年份查询年计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.YearRequest,
): Promise<defs.StandardReturn<defs.PlanYearInfoResponse>> {
  return defHttp.post({
    url: '/wap/plan/year/queryPlanInfoByYear',
    data,
  });
}

export function mock(
  data: defs.YearRequest,
): Promise<defs.StandardReturn<defs.PlanYearInfoResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/year/queryPlanInfoByYear',
    data,
  });
}
